import React, {Fragment} from 'react';
import {Goals, Redirect, Route, Switch, Layout} from 'components';
import {useNamedSelector} from 'helpers';
import {RouteComponentProps} from 'types';

export function Router({match: {params: {id}}}: RouteComponentProps<{id: string}>) {
  const {goal} = useNamedSelector('goals.details', {id});
  if (goal) {
    return (
      <Fragment>
        <Layout.Title>{goal.name} - Goals</Layout.Title>
        <Switch>
          <Route path="/goals/track/:id/" component={Goals.Single.Track} />
          <Route path="/goals/:id/milestones/" component={Goals.Milestones.List} />
          <Route path="/goals/:id/edit/" component={Goals.Single.EditForm} />
          <Route path="/goals/:id/review" component={Goals.Single.Review} />
          <Route path="/goals/:id/" component={Goals.Single.Plan} />
        </Switch>
      </Fragment>
    );
  }
  return (
    <Redirect to="/goals/" />
  );
}
